import { createAction } from '@reduxjs/toolkit';
import {
  AccountAdminData,
  CREATE_ENROLLMENT,
  CREATE_ENROLLMENT_FAIL,
  CREATE_ENROLLMENT_SUCCESS,
  EnrollmentStep,
  EnrollmentType,
  EntityInfoFormData,
  SET_ACCOUNT_ADMIN_ONE,
  SET_ACCOUNT_ADMIN_ONE_SUCCESS,
  SET_ACCOUNT_ADMIN_ONE_FAIL,
  SET_ACCOUNT_ADMIN_TWO,
  SET_ACCOUNT_ADMIN_TWO_SUCCESS,
  SET_ACCOUNT_ADMIN_TWO_FAIL,
  SET_ACTIVE_STEP,
  SET_ENROLLMENT_TYPE,
  SET_ENTITY_INFO,
  SET_ENTITY_INFO_FAIL,
  SET_ENTITY_INFO_SUCCESS,
  SET_IS_DFIN_ADMIN,
  SET_IS_DFIN_ADMIN_FAIL,
  SET_IS_DFIN_ADMIN_SUCCESS,
  UPLOAD_TEMPLATE_FILE,
  UPLOAD_TEMPLATE_FILE_SUCCESS,
  UPLOAD_TEMPLATE_FILE_FAIL,
  ENROLL,
  ENROLL_SUCESS,
  ENROLL_FAIL,
  GET_EDGAR_STATUS,
  GET_EDGAR_STATUS_SUCESS,
  GET_EDGAR_STATUS_FAIL,
  GET_LATEST_ENROLLMENT,
  GET_LATEST_ENROLLMENT_SUCCESS,
  GET_LATEST_ENROLLMENT_FAIL,
  CONTINUE_ENROLLMENT,
  CONTINUE_ENROLLMENT_SUCCESS,
  CONTINUE_ENROLLMENT_FAIL,
  RESET_ENROLLMENT,
  RESET_STEP_IDS_AFTER_BULK_UPLOAD,
} from './enrollmentModel';

export const setActiveStep = createAction(
  SET_ACTIVE_STEP,
  (step: EnrollmentStep) => ({
    payload: { step },
  })
);

export const setIsDFINAdmin = createAction(
  SET_IS_DFIN_ADMIN,
  (isDFINAdmin: boolean) => ({
    payload: { isDFINAdmin },
  })
);
export const setIsDFINAdminSuccess = createAction(
  SET_IS_DFIN_ADMIN_SUCCESS,
  (isDFINAdmin: boolean, stepId: string) => ({
    payload: { isDFINAdmin, stepId },
  })
);
export const setIsDFINAdminFail = createAction(SET_IS_DFIN_ADMIN_FAIL);

export const setEntityInfo = createAction(
  SET_ENTITY_INFO,
  (entityInfo: EntityInfoFormData) => ({
    payload: { entityInfo },
  })
);
export const setEntityInfoSuccess = createAction(
  SET_ENTITY_INFO_SUCCESS,
  (entityInfo: EntityInfoFormData, stepId: string) => ({
    payload: { entityInfo, stepId },
  })
);
export const setEntityInfoFail = createAction(SET_ENTITY_INFO_FAIL);

export const uploadTemplateFile = createAction(
  UPLOAD_TEMPLATE_FILE,
  (file: File) => ({
    payload: { file },
  })
);
export const uploadTemplateFileSuccess = createAction(
  UPLOAD_TEMPLATE_FILE_SUCCESS,
  (entityNames: string[]) => ({
    payload: { entityNames },
  })
);
export const uploadTemplateFileFail = createAction(
  UPLOAD_TEMPLATE_FILE_FAIL,
  (errorMsg?: string) => ({
    payload: { errorMsg },
  })
);

export const setEnrollmentType = createAction(
  SET_ENROLLMENT_TYPE,
  (enrollmentType: EnrollmentType) => ({
    payload: { enrollmentType },
  })
);

export const setAccountAdminOne = createAction(
  SET_ACCOUNT_ADMIN_ONE,
  (accountAdminOne: AccountAdminData) => ({
    payload: { accountAdminOne },
  })
);

export const setAccountAdminOneSuccess = createAction(
  SET_ACCOUNT_ADMIN_ONE_SUCCESS,
  (accountAdminOne: AccountAdminData, stepId: string) => ({
    payload: { accountAdminOne, stepId },
  })
);

export const setAccountAdminOneFail = createAction(SET_ACCOUNT_ADMIN_ONE_FAIL);

export const setAccountAdminTwo = createAction(
  SET_ACCOUNT_ADMIN_TWO,
  (accountAdminTwo: AccountAdminData) => ({
    payload: { accountAdminTwo },
  })
);

export const setAccountAdminTwoSuccess = createAction(
  SET_ACCOUNT_ADMIN_TWO_SUCCESS,
  (accountAdminTwo: AccountAdminData, stepId: string) => ({
    payload: { accountAdminTwo, stepId },
  })
);

export const setAccountAdminTwoFail = createAction(SET_ACCOUNT_ADMIN_TWO_FAIL);

export const createEnrollment = createAction(
  CREATE_ENROLLMENT,
  (callback: () => void) => ({
    payload: { callback },
  })
);
export const createEnrollmentSuccess = createAction(
  CREATE_ENROLLMENT_SUCCESS,
  (enrollmentId: string) => ({
    payload: { enrollmentId },
  })
);
export const createEnrollmentFail = createAction(CREATE_ENROLLMENT_FAIL);

export const enroll = createAction(ENROLL);
export const enrollSuccess = createAction(ENROLL_SUCESS);
export const enrollFail = createAction(ENROLL_FAIL);

export const getEdgarStatus = createAction(GET_EDGAR_STATUS);
export const getEdgarStatusSuccess = createAction(
  GET_EDGAR_STATUS_SUCESS,
  (isEdgarAvailable: boolean) => ({
    payload: { isEdgarAvailable },
  })
);
export const getEdgarStatusFail = createAction(GET_EDGAR_STATUS_FAIL);

export const getLatestEnrollment = createAction(GET_LATEST_ENROLLMENT);
export const getLatestEnrollmentSuccess = createAction(
  GET_LATEST_ENROLLMENT_SUCCESS,
  (enrollmentId: string) => ({
    payload: { enrollmentId },
  })
);
export const getLatestEnrollmentFail = createAction(GET_LATEST_ENROLLMENT_FAIL);

export const continueEnrollment = createAction(
  CONTINUE_ENROLLMENT,
  (enrollmentId: string) => ({
    payload: { enrollmentId },
  })
);
export const continueEnrollmentSuccess = createAction(
  CONTINUE_ENROLLMENT_SUCCESS,
  (enrollmentId: string) => ({
    payload: { enrollmentId },
  })
);
export const continueEnrollmentFail = createAction(CONTINUE_ENROLLMENT_FAIL);

export const resetEnrollment = createAction(RESET_ENROLLMENT);

export const resetStepIdsAfterBulk = createAction(
  RESET_STEP_IDS_AFTER_BULK_UPLOAD
);
